import { $getSelection, $isRangeSelection, ElementNode, type LexicalEditor } from 'lexical';

export type Alignment = 'left' | 'center' | 'right' | 'justify';

export function applyAlignment(editor: LexicalEditor, alignment: Alignment) {
    editor.update(() => {
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
            const nodes = selection.getNodes();

            for (const node of nodes) {
                // Handle block container only
                const parent = node.getParent();

                if (
                    parent &&
                    parent instanceof ElementNode &&
                    typeof parent.setFormat === 'function'
                ) {
                    parent.setFormat(alignment);
                } else if (node instanceof ElementNode && typeof node.setFormat === 'function') {
                    node.setFormat(alignment);
                }
            }
        }
    });
}
